import { createAsyncThunk } from '@reduxjs/toolkit';
import { activateInvoiceScanningAddress } from '../services/activateInvoiceScanningAddress';

export const activateInvoiceScanningAddressThunk = createAsyncThunk(
  'invoices/activateInvoiceScanningAddress',
  async (params, { getState, dispatch }) => {
    const businessId = params.businessId;
    const email = params.email;
    if (!businessId) {
      throw new Error('Business ID is required');
    }
    if (!email) {
      throw new Error('Email is required');
    }

    const response = await activateInvoiceScanningAddress(businessId, email);

    return response;
  }
);
